import { AuthService } from "../service/auth.service";
import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "src/app/services/app/app.service";
import { GlobalService } from "src/app/services/global/global.service";
import { AlertComponent } from "src/app/pages/alert/alert.component";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "src/environments/environment";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService, private loadingSerivce: NgxSpinnerService, private appService: AppService, private globalService: GlobalService,
    private dialog: MatDialog) { }

  // intercept(
  //   request: HttpRequest<any>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<any>> {
  //   return next.handle(request).pipe(
  //     catchError((err) => {
  //       if (err.status === 401) {
  //         // auto logout if 401 response returned from api
  //         this.authenticationService.logout();
  //         location.reload();
  //       }

  //       const error = err.error.message || err.statusText;
  //       return throwError(error);
  //     })
  //   );
  // }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        this.loadingSerivce.hide()
        if (error.error instanceof ErrorEvent) {
          // client-side error
          alert(JSON.stringify(error.error.message))
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          // alert(JSON.stringify(error.error.msg))
          //if unauthorized logout the user,
          if (error.status == 401) {
            // this.appService.showToastMessage('error',error.error.msg);
            if (this.appService.getSessionData('isAdmin')) {
              // consoe
              this.appService.showToastMessage('error', "Session expired! Please log in again.");
              // when user is navigated to admin panel login page there reload will occur and user will be taken out
              window.open(environment.adminLogOutUrl, "_self")
              //window.location.reload();
            }
            else {
              this.appService.showToastMessage('error', "Session expired! Please log in again.");
              this.appService.logOut()
            }

          }
          else {
            //error toast will not be displayed if message is blank
            // if(error.)

            if (error.error.status == 406 && (error.error.msg == "Data not found" || error.error.msg == "Data not found.")) { }
            else if (error.status == 500) {
              this.callAlert()
            }
            else {
              if (error.error.msg) {
                this.appService.showToastMessage('error', error.error.msg)
              }
            }

          }
        }
        console.error(errorMessage);
        return throwError(errorMessage);
      })
    );
  }

  callAlert() {
    const dialogRef = this.dialog.open(AlertComponent, Object.assign({
      data: { api_type: 'error', }
    }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
}
